import React from "react";
import { RaisedButton, Popover, Menu, MenuItem } from "material-ui";
import OrderStore from "../../stores/OrderStore";
import OrderActions from "../../actions/OrderActions";
import connectToStores from "alt-utils/lib/connectToStores";

class AddPassToCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null
    };

    this.handleClick = this.handleClick.bind(this);
    this.getStyles = this.getStyles.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    tenant: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

  static getStores() {
    return [OrderStore];
  }

  static getPropsFromStores() {
    return {};
  }

  handleClick(e, passBucketId) {
    e.preventDefault();

    const cartOrder = OrderStore.getCartOrder();
    let updatedSubitems = cartOrder.subitems;

    // if pass already exists as subitem, up the quantity
    let subitemExists = false;
    for (let y=0; y < updatedSubitems.length; y++) {
      let thisSubitem = updatedSubitems[y];
      if (thisSubitem.pass_bucket && thisSubitem.pass_bucket === passBucketId) {
        thisSubitem.quantity++;
        subitemExists = true;
        break;
      }
    }
    // otherwise, add new subitem
    if (!subitemExists) {
      updatedSubitems.push({
        pass_bucket: passBucketId,
        quantity: 1
      });
    }

    OrderActions.updateCart({ subitems: updatedSubitems });
  }

  _onClose() {
    this.setState({ open: false });
  }

  getStyles() {
    return {
      menu: {
        maxWidth: this.context.isLarge ? 600 : "60vw",
        textAlign: "left"
      },
      menuItem: {
        cursor: "pointer",
        whiteSpace: "inherit",
        lineHeight: "25px",
        minHeight: "inherit",
        paddingTop: 4,
        paddingBottom: 4
      }
    };
  }

  render() {
    let { label, passBucketId, disabled } = this.props,
      styles = this.getStyles();

    return (
      <div style={{ display: "inline-block" }}>
        <RaisedButton
          className="eventive__pass-button__button"
          disabled={disabled}
          label={label}
          primary={true}
          onClick={(e) => { this.handleClick(e, passBucketId); }}
        />
      </div>
    );
  }
}

export default connectToStores(AddPassToCartButton);



// WEBPACK FOOTER //
// ./src/app/components/partials/add-pass-to-cart-button.jsx